import React from "react";
import { useTranslation } from "react-i18next";
import Arrows from "../Arrows";
import styles from "../styles.module.scss";

const SortableLabel = ({
  label,
  sortBy,
  order,
  setSort,
  className,
  field = null,
}) => {
  const isSet = sortBy === field;
  const arrowDirection = order === "asc";
  const { t } = useTranslation();

  const onClick = () => {
    setSort(field, order === "asc" ? "desc" : "asc");
  };

  return (
    <div onClick={onClick} className={className}>
      <span className={styles.sortable_label}>{t(label)}</span>
      <Arrows order={arrowDirection} isSet={isSet} />
    </div>
  );
};

export default SortableLabel;
